export let strings = {
  'title':
    'Schulte table',

  'description':
    'Test switching and distribution of attention. Can be used for examining children and adults.',

  'block':
    'Block',

  'startButton':
    'Continue',

  'applyButton':
    'Start',

  'brief_1':
    'The screen shows 25 red and 24 black tiles. You should find the black tiles as soon as possible in ascending order (from 1 to 24) and click them.',

  'brief_2':
    'On the screen you should find the red tiles as soon as possible in descending order (from 25 to 1). Find the required number and click.',

  'brief_3':
    'On the screen you should find the red tiles as soon as possible in descending order and black numbers in increasing order alternately. For example, a red tile is 25, a black tile is 1, a red tile is 24, a black tile is 2, and so on. Find the required tile and click.',

  'step':
    'Step',

  'from':
    'of',

  'hint':
    'Hint',

  'blockResults':
    'Block result',

  'resultsText':
    'You finish this block',

  'time':
    'Time',

  'mistakes':
    'Mistakes number',

  'continueButton':
    'Continue',

  'finish':
    'Thank you!',

  'finishText':
    'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam dolorum consequatur dolore dicta, ipsam! Corporis reprehenderit fugit, ipsam, reiciendis numquam sapiente tempora aperiam dolores consectetur distinctio neque cupiditate corrupti commodi!',

  'back':
    'Finish test'
}



// WEBPACK FOOTER //
// ./src/strings.js